
import { AbpModule, TokenService } from 'abp-ng2-module';
import * as ngCommon from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LinkAccountModalComponent } from '@app/shared/layout/link-account-modal.component';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { FileUploadModule } from 'ng2-file-upload';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { FileUploadModule as PrimeNgFileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ImpersonationService } from './admin/users/impersonation.service';
import { FileUploadSendEmailService } from '@app/shared/common/fileupload/file-upload.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCommonModule } from './shared/common/app-common.module';
import { FooterComponent } from './shared/layout/footer.component';
import { HeaderComponent } from './shared/layout/header.component';
import { LinkedAccountService } from './shared/layout/linked-account.service';
import { SideBarMenuComponent } from './shared/layout/nav/side-bar-menu.component';
import { TopBarMenuComponent } from './shared/layout/nav/top-bar-menu.component';
import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { HeaderNotificationsComponent } from './shared/layout/notifications/header-notifications.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpCancelService } from 'services/project.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxCaptureModule } from 'ngx-capture';
import { DeferredScriptService, GoogleTagManagerService } from './main/cablepro/google-tag-manager.service';
import { PopoverModule } from '@easiangular/ngx-smart-popover';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from 'angularx-social-login';
import { environment } from 'environments/environment';
import { LoaderComponent } from './main/cablepro/loader.component';
import { LoaderService } from './main/cablepro/loader.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './shared/common/confirmation-modal/confirmation-modal.component';
import { NavigationService } from './main/cablepro/navigation.service';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { CustomTokenService } from 'services/custom-token.service';
import { PwaInstallService } from '@shared/service-proxies/EventEmitterService';
import { AppInstallPopupComponent } from './shared/layout/app-install-popup/app-install-popup.component';
import { TrialBannerComponent } from './shared/layout/trial-banner/trial-banner.component';
import { SanitizeHtmlPipe } from './main/subscriptions/sanitize-html.pipe';

//isld part
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {ISldRootComponent}  from "../app/main/cablepro/Network/isld/isld-root/isld-root.component"

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        HeaderNotificationsComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        FooterComponent,
        LoginAttemptsModalComponent,
        LinkedAccountsModalComponent,
        LinkAccountModalComponent,
        ChangeProfilePictureModalComponent,
        NotificationsComponent,
        NotificationSettingsModalComponent,
        ConfirmationModalComponent 
               
    ],
    imports: [
        ngCommon.CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        ModalModule,
        TooltipModule,
        TabsModule,
        FileUploadModule,
        AbpModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ServiceProxyModule,
        TableModule,
        PaginatorModule,
        NgxPaginationModule,
        PrimeNgFileUploadModule,
        ProgressBarModule, BrowserAnimationsModule,
        OrderModule,
        NgxCaptureModule,
        PopoverModule,
        NgSelectModule,
        NgxSkeletonLoaderModule.forRoot(),
        SocialLoginModule,
        LoaderComponent,
        AppInstallPopupComponent,
        TrialBannerComponent
    ],
    providers: [
        { provide: TokenService, useClass: CustomTokenService },
        ImpersonationService,
        LinkedAccountService,
        UserNotificationHelper,
        NgbActiveModal,
        FileUploadSendEmailService,
        HttpCancelService,
        GoogleTagManagerService,
        DeferredScriptService,
        LoaderService,
        NavigationService,
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(
                            environment.GoogleClientId,
                            {
                                scope: 'profile email',
                                plugin_name: 'CablePro', //can be any name
                                prompt: 'select_account'
                            }
                        )
                    }
                ],
                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        },
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false || 'none'
                }
            }
        }),
        {
            provide: APP_INITIALIZER,
            useFactory: initPwa,
            deps: [PwaInstallService],
            multi: true
        }
        
    ],
     schemas: [CUSTOM_ELEMENTS_SCHEMA]   // allow <react-flow-diagram>
})
export class AppModule { }


export function initPwa(pwaService: PwaInstallService) {
    return () => {
        // Just referencing the service ensures it's created immediately
    };
}
